// import React from 'react';
// // import { useNavigate } from 'react-router-dom';
// import "./start-page.css"
// // import GalleryCarousel from '../structure-page/gallery-carousel';
// // import startGalleryDB from './start-image-db';

// function StartPage() {
//   // const navigate = useNavigate();

//   const handleLinkClick = (id) => {
//     const section = document.getElementById(id);
//     if (section) {
//       section.scrollIntoView({ behavior: "smooth" }); // Scroll to the section smoothly
//       window.history.replaceState(null, "", window.location.pathname); // Clear the # from the URL
//     }
//   };

//   return (
//     <div className='main-page'>
//       <div className='profile-wrapper'>
//         <div className='profile-name'>
//           <h4><b>Thanh Nguyen Do</b></h4>
//           <div>
//             <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" className="bi bi-battery-charging unique-icon-start" viewBox="0 0 16 16">
//                 <path d="M9.585 2.568a.5.5 0 0 1 .226.58L8.677 6.832h1.99a.5.5 0 0 1 .364.843l-5.334 5.667a.5.5 0 0 1-.842-.49L5.99 9.167H4a.5.5 0 0 1-.364-.843l5.333-5.667a.5.5 0 0 1 .616-.09z"/>
//                 <path d="M2 4h4.332l-.94 1H2a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h2.38l-.308 1H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2"/>
//                 <path d="M2 6h2.45L2.908 7.639A1.5 1.5 0 0 0 3.313 10H2zm8.595-2-.308 1H12a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H9.276l-.942 1H12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"/>
//                 <path d="M12 10h-1.783l1.542-1.639c.097-.103.178-.218.241-.34zm0-3.354V6h-.646a1.5 1.5 0 0 1 .646.646M16 8a1.5 1.5 0 0 1-1.5 1.5v-3A1.5 1.5 0 0 1 16 8"/>
//             </svg>
//           </div>
//         </div>  

//         <div className='start-page-info'>
//           <span>
//             <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" className="bi bi-briefcase unique-icon-start" viewBox="0 0 16 16">
//               <path d="M6.5 1A1.5 1.5 0 0 0 5 2.5V3H1.5A1.5 1.5 0 0 0 0 4.5v8A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-8A1.5 1.5 0 0 0 14.5 3H11v-.5A1.5 1.5 0 0 0 9.5 1zm0 1h3a.5.5 0 0 1 .5.5V3H6v-.5a.5.5 0 0 1 .5-.5m1.886 6.914L15 7.151V12.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5V7.15l6.614 1.764a1.5 1.5 0 0 0 .772 0M1.5 4h13a.5.5 0 0 1 .5.5v1.616L8.129 7.948a.5.5 0 0 1-.258 0L1 6.116V4.5a.5.5 0 0 1 .5-.5"/>
//             </svg>
//           </span>
//           <h5>CS Grad at <b>Texas Christian University</b></h5>
//         </div>
//         <div className='start-page-info'>
//           <span>
//             <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" className="bi bi-person-workspace unique-icon-start" viewBox="0 0 16 16">
//               <path d="M4 16s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1zm4-5.95a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"/>
//               <path d="M2 1a2 2 0 0 0-2 2v9.5A1.5 1.5 0 0 0 1.5 14h.653a5.373 5.373 0 0 1 1.066-2H1V3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v9h-2.219c.554.654.89 1.373 1.066 2h.653a1.5 1.5 0 0 0 1.5-1.5V3a2 2 0 0 0-2-2z"/>
//             </svg>
//           </span>
//           <h5>Texas-Based Software Engineer & Full-Stack Developer</h5>
//         </div>
        
//         <button className="start-cv-btn" onClick={() => handleLinkClick("about-block")}>
//           About me
//         </button>
//       </div>

//       {/* <div className='main-page-image-start'>
//         <GalleryCarousel imagesDB={startGalleryDB} />
//       </div> */}
//     </div>
//   );
// }

// export default StartPage;
import React, { useEffect, useRef } from "react";
import "./start-page.css";

function StartPage() {
  const heroRef = useRef(null);
  const ctaWrapRef = useRef(null);

  const handleLinkClick = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
      window.history.replaceState(null, "", window.location.pathname);
    }
  };

  // Optional: magnetic effect for CTA buttons (feels premium)
  useEffect(() => {
    const wrap = ctaWrapRef.current;
    if (!wrap) return;

    const buttons = Array.from(wrap.querySelectorAll(".hero-btn"));
    const strength = 14; // lower = subtler

    const onMove = (e, btn) => {
      const r = btn.getBoundingClientRect();
      const dx = e.clientX - (r.left + r.width / 2);
      const dy = e.clientY - (r.top + r.height / 2);

      const mx = (dx / r.width) * strength;
      const my = (dy / r.height) * strength;

      btn.style.transform = `translate3d(${mx}px, ${my}px, 0)`;
    };

    const onLeave = (btn) => {
      btn.style.transform = "translate3d(0,0,0)";
    };

    const handlers = buttons.map((btn) => {
      const move = (e) => onMove(e, btn);
      const leave = () => onLeave(btn);

      btn.addEventListener("mousemove", move);
      btn.addEventListener("mouseleave", leave);
      return { btn, move, leave };
    });

    return () => {
      handlers.forEach(({ btn, move, leave }) => {
        btn.removeEventListener("mousemove", move);
        btn.removeEventListener("mouseleave", leave);
      });
    };
  }, []);

  return (
    <section ref={heroRef} className="hero main-page">
      {/* Background layers */}
      {/* <div className="hero-grid" aria-hidden="true" />
      <div className="hero-glow" aria-hidden="true" /> */}

      <div className="hero-inner">
        {/* Left content */}
        <div className="hero-left">
          <div className="hero-kicker">
            <span className="hero-dot" />
            <span>CS Grad @ TCU • Shipping Real Projects</span>
          </div>

          <h1 className="hero-title">
            Hello! I’m <span className="hero-title-accent">Thanh Nguyen Do</span>
          </h1>

          <p className="hero-subtitle">
            Full-Stack Engineer focused on building clean, scalable products with
            strong UX — from API design and databases to polished interfaces.
          </p>

          <div ref={ctaWrapRef} className="hero-cta">
            <button
              className="hero-btn secondary cursor-pointer"
              onClick={() => handleLinkClick("project-block")}
            >
              View Projects →
            </button>

            <button
              className="hero-btn primary cursor-pointer"
              onClick={() => handleLinkClick("about-block")}
            >
              About Me
            </button>
          </div>

          <div className="hero-meta">
            <a className="hero-link cursor-pointer" href="#contact-block" onClick={(e) => {e.preventDefault(); handleLinkClick("contact-block");}}>
              Contact
            </a>
            <span className="hero-sep">•</span>
            <a className="hero-link cursor-pointer" href="https://github.com/richardcodes25" target="_blank" rel="noreferrer">
              GitHub
            </a>
            <span className="hero-sep">•</span>
            <a className="hero-link cursor-pointer" href="https://www.linkedin.com/in/richarddo25/" target="_blank" rel="noreferrer">
              LinkedIn
            </a>
          </div>
        </div>

        {/* Right visual */}
        <div className="hero-right" aria-hidden="true">
          <div className="hero-card">
            <div className="hero-card-top">
              <div className="hero-pill">Currently building</div>
              <div className="hero-mini">Production-ready web apps</div>
            </div>

            <div className="hero-card-mid">
              <div className="hero-stat">
                <div className="hero-stat-num">Full-Stack</div>
                <div className="hero-stat-label">MERN stack • MEAN stack • Spring</div>
              </div>
              <div className="hero-stat">
                <div className="hero-stat-num">DataBase</div>
                <div className="hero-stat-label">PostgreSQL • MongoDB • Indexing</div>
              </div>
              <div className="hero-stat">
                <div className="hero-stat-num">DevOps</div>
                <div className="hero-stat-label">Docker • Kubernetes • GitHub Actions</div>
              </div>
            </div>

            <div className="hero-card-bottom">
              <div className="chip float-1">🗄️ PostgreSQL</div>
              <div className="chip float-2">☕ Spring</div>
              <div className="chip float-3">🐳 Docker</div>
              <div className="chip float-4">☁️ Oracle</div>
              <div className="chip float-5">⚛️ React</div>
              <div className="chip float-6">Angular</div>
              <div className="chip float-7">🧠 System Design</div>
            </div>
          </div>

          <div className="orb orb-1" />
          <div className="orb orb-2" />
        </div>
      </div>
    </section>
  );
}

export default StartPage;
